export const GenericWordDateFormat = 'dd MMM, yyyy';
export const GenericMonthDayDateFormat = 'MMM d';
